import { AppAreaConfig } from '@/funnels/@types'
import walkingMale from './activity-male-walking'
import walkingLymphaticFemalePr from './activity-female-lymphatic-walking-pr'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-lymphatic-walking-pr',
	landing: {
		// The loader is identical to the base selector's in the design (Figma `age selection`
		// 23768:97324 renders the same `main_walking.lymphatic.loader.title`), so it is reused
		// rather than duplicated. Only the age picker gains the printable banner.
		ids: ['loader-lymphatic-walking', 'age-lymphatic-walking-pr'],
		route: {
			path: '/lymphatic-walking-pr',
			name: 'main-lymphatic-walking-pr-funnel',
		},
	},
	funnel: {
		id: 'ob-lymphatic-walking-gender-selection-pr',
		route: {
			path: '/lymphatic-walking-pr/ob/:page(.*)?',
			name: 'main-lymphatic-walking-pr',
		},
		slug: 'main-lymphatic-walking-pr',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				// Male keeps the plain walking funnel — no printable variant exists for it. Both the
				// PRD ("Male - walking male") and the Figma flow (the male row is labelled "Walking
				// Male", 23768:98109) say so; `main-tai-chi-walking-pr` ships the same asymmetry.
				male: { appArea: walkingMale },
				female: { appArea: walkingLymphaticFemalePr },
			},
		},
	},
}

export default appAreaConfig
